var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectDropDown',{attrs:{"id":_vm.id,"name":_vm.name,"options":_vm.regions,"defaultSelected":_vm.regions[0]},on:{"selection-change":_vm.regionSelected}})}
var staticRenderFns = []

export { render, staticRenderFns }